import { render, staticRenderFns } from "./application-form-budget-msu.vue?vue&type=template&id=51bfb2fc&scoped=true&"
import script from "./application-form-budget-msu.vue?vue&type=script&lang=js&"
export * from "./application-form-budget-msu.vue?vue&type=script&lang=js&"
import style0 from "./application-form-budget-msu.vue?vue&type=style&index=0&id=51bfb2fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51bfb2fc",
  null
  
)

export default component.exports